module.exports = "/components/directives/personaPicker-dea706.html";